import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }              from '../api/api.service';
import { ConfirmService }          from '../messages/confirm/confirm.service';
import { InvoiceModel }            from '../invoices/models/invoice';
import { InvoiceService }          from '../invoices/invoice.service';
import { LOAN_STATUS_PENDING }     from './loan-car.constants';
import { LoanCarVehicleComponent } from './loan-car.vehicle.component';
import { LoanCarVehicleModel }     from './typings/loan-car.vehicle';
import { MessagesService }         from '../messages/messages.service';

@Injectable({
  providedIn: 'root'
})
export class LoanCarService {
  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private invoiceService  : InvoiceService,
    private messagesService : MessagesService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  // Resolves false, after saying why, for a loan that has started or whose job card is no longer open.
  deleteLoanCar ( loanCarId : string, loanStatus : string, invoice ?: InvoiceModel ) : Promise<boolean> {
    const hasClosedJobCard : boolean = !!(invoice && invoice.invoice_status && !this.invoiceService.isStatus(invoice, 'open'));

    if (loanStatus !== LOAN_STATUS_PENDING || hasClosedJobCard) {
      this.messagesService.show(this.translateService.instant('LOAN_CAR_SPACE.LOAN_CAR_NOT_DELETABLE'), 'warning');

      return Promise.resolve(false);
    }

    return this.confirmService.generic(this.translateService.instant('LOAN_CAR_SPACE.DELETE_LOAN_CAR'))
    .then(() => this.apiService.delete('/loan_car', loanCarId))
    .then(() => true);
  }

  deleteLoanVehicle ( loanVehicle : LoanCarVehicleModel ) : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_LOAN_VEHICLE'))
    .then(() => this.apiService.delete('/loan_vehicle', loanVehicle.id));
  }

  manageLoanVehicle ( id : string ) : Promise<any> {
    return Promise.resolve()
    .then(() => id
      ? this.apiService.get('/loan_vehicle', id)
      : null
    )
    .then(( loanVehicle : any ) => {
      const modal = this.modalService.open(LoanCarVehicleComponent, {
        size: 'lg'
      });

      modal.componentInstance.loanVehicle = loanVehicle;

      return modal.result;
    });
  }

  saveVehicle ( loanVehicle : LoanCarVehicleModel ) : Promise<any> {
    return this.apiService.post('/loan_vehicles', loanVehicle, 'loan_vehicle');
  }

  updateVehicle ( loanVehicle : LoanCarVehicleModel ) : Promise<any> {
    return this.apiService.patch('/loan_vehicle', loanVehicle, 'loan_vehicle');
  }
}
